import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import React, { Fragment } from "react";
import { FilterByDate, FilterByEmail, FilterByOrg, HeaderActionButtons } from "../controls";
import { GRID_ROWS_PER_PAGE_OPTIONS } from "../../../../constants";
import ListContainer from "../../../list";
import { getI18n } from "../../../../utils/intl";
import { useIntl } from "react-intl";
import styles from '../styles';
import {
  getErrors,
  getIsLoading, getListResults, getListTotalElements, getListTotalPages,
  getOrgSuggestions,
  getRequestUpdateStatus,
} from "../../../../reducers/request";
import { getUserDetails } from "../../../../reducers/portalConfig";
import {
  fetchList,
  fetchOrgSuggestions,
  submitRequest,
} from "../../../../actions/requests";
import { push } from "connected-react-router";
import { array, arrayOf, bool, func, instanceOf, number, shape, object, string } from "prop-types";

export const UserRequestsList = (props) => {
  const {
    classes,
    isLoading,
    notificationStatus,
    setNotificationStatus,
    notificationMessage,
    setNotificationMessage,
    filterByEmail,
    onFilterByEmailChange,
    onFilterByEmailKeyPress,
    filterByEmailType,
    filterByEmailTypeOptions,
    onFilterByEmailTypeChange,
    onFilterByOrgChange,
    onOrgSelection,
    orgSearchText,
    orgSuggestions,
    filterByOrg,
    getListColumns,
    rows,
    page,
    totalElements,
    totalPages,
    rowsPerPage,
    onChangeRowsPerPage,
    onChangePage,
    onChangePreviousPage,
    onChangeNextPage,
    emptyFunction,
    handleAccept,
    handleReject,
    filterByStartDate,
    onFilterByStartDateChange,
    filterByEndDate,
    onFilterByEndDateChange,
    onClearFilterByDate,
    onDateRangeError,
    selectedRows,
    setSelectedRows,
  } = props;

  const { getI18nMessage } = getI18n(useIntl());
  return (
    <ListContainer
      listPageId="user-request-list"
      isLoading={isLoading}
      classes={classes}
      notificationId="request-notifications"
      notificationStatus={notificationStatus}
      setNotificationStatus={setNotificationStatus}
      notificationMessage={notificationMessage}
      setNotificationMessage={setNotificationMessage}
      hasNotificationIcon={true}
      addButtonLabel={''}
      onAdd={false}
      showListHeader={true}
      filterAndSortContent={(
        <Fragment>
          <FilterByEmail
            selectData={filterByEmailTypeOptions}
            selectContainerClass={classes.emailTypeContainerClass}
            selectFieldClass={classes.emailTypeFieldClass}
            selectHandleChange={onFilterByEmailTypeChange}
            selectValue={filterByEmailType}
            textFieldContainerClass={classes.nameFieldContainer}
            textFieldClass={classes.emailFieldClass}
            textFieldHandleChange={onFilterByEmailChange}
            textFieldKeyPress={onFilterByEmailKeyPress}
            textFieldValue={filterByEmail}
            textFieldPlaceholder={getI18nMessage("label.request.filterby.placeholder.email")}
            name={getI18nMessage('label.filter')}
          />
          <FilterByOrg
            fieldContainerClass={classes.fieldContainer}
            filterSelectedOptions={false}
            hideLabel
            name={getI18nMessage('label.filter.by')}
            onInputChange={(event, value) => onFilterByOrgChange(value)}
            onChange={(event, value) => onOrgSelection(value)}
            options={orgSuggestions}
            inputLabel={getI18nMessage('label.request.org')}
            searchText={orgSearchText}
            value={filterByOrg}
          />
          <FilterByDate
            containerClass={classes.dateRangeContainerClass}
            startDate={filterByStartDate}
            onStartDateChange={onFilterByStartDateChange}
            endDate={filterByEndDate}
            onEndDateChange={onFilterByEndDateChange}
            onClear={onClearFilterByDate}
            onDateRangeError={onDateRangeError}
            startDatePlaceholder={getI18nMessage("label.daterangepicker.start.date.placeholder")}
            endDatePlaceholder={getI18nMessage("label.daterangepicker.end.date.placeholder")}
          />
        </Fragment>
      )}
      columns={getListColumns({ getI18nMessage, classes })}
      rows={rows}
      noResultsMessage={getI18nMessage('label.request.list.no.results')}
      page={page}
      totalElements={totalElements}
      totalPages={totalPages}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={GRID_ROWS_PER_PAGE_OPTIONS}
      onChangeRowsPerPage={onChangeRowsPerPage}
      onChangePage={onChangePage}
      onChangePreviousPage={onChangePreviousPage}
      onChangeNextPage={onChangeNextPage}
      notifyMessages={emptyFunction}
      pageFilterAndSortClass={classes.pageFilterAndSortClass}
      bulkActionsContent={<HeaderActionButtons
          {...props}
          id={'request-users-list-header'}
          fieldContainerClass={classes.fieldContainer}
          bulkActionsItemsCount={selectedRows.length}
          classes={classes}
          onBulkAccept={() => handleAccept(selectedRows)}
          onBulkReject={() => handleReject(selectedRows)}
        />
      }
      setSelectedRows={setSelectedRows}
      selectedRows={selectedRows}
    />
  )
};

UserRequestsList.propTypes = {
  classes: shape({}),
  isLoading: bool,
  notificationStatus: string,
  setNotificationStatus: func,
  notificationMessage: string,
  setNotificationMessage: func,
  onFilterByEmailChange: func,
  filterByEmail: string,
  filterByEmailType: string,
  filterByEmailTypeOptions: arrayOf(object),
  onFilterByEmailTypeChange: func,
  onFilterByEmailKeyPress: func,
  onFilterByOrgChange: func,
  onOrgSelection: func,
  orgSearchText: string,
  orgSuggestions: arrayOf(shape({})),
  filterByOrg: string,
  getListColumns: func,
  rows: arrayOf(object),
  page: number,
  totalElements: number,
  totalPages: number,
  rowsPerPage: number,
  onChangeRowsPerPage: func,
  onChangePage: func,
  onChangePreviousPage: func,
  onChangeNextPage: func,
  emptyFunction: func,
  handleAccept : func,
  handleReject : func,
  filterByStartDate : instanceOf(Date),
  onFilterByStartDateChange : func,
  filterByEndDate : instanceOf(Date),
  onFilterByEndDateChange : func,
  onClearFilterByDate : func,
  onDateRangeError : func,
  selectedRows : array,
  setSelectedRows : func,
};

UserRequestsList.displayName = 'UserRequests';

const mapStateToProps = (state) => ({
  isLoading: getIsLoading(state),
  orgSuggestions: getOrgSuggestions(state),
  requestUpdateStatus: getRequestUpdateStatus(state),
  results: getListResults(state),
  totalElements: getListTotalElements(state),
  totalPages: getListTotalPages(state),
  user: getUserDetails(state),
  errors: getErrors(state),
});

const mapDispatchToProps = {
  fetchList,
  fetchOrgSuggestions,
  submitRequest,
  push,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(UserRequestsList);
